module.exports = __webpack_public_path__ + "static/icon-aed6e0e72ce40ef9d56a066b0ff35d1e.png";